import React from "react";
import styled from "@emotion/styled";

const ContainerDiv = styled.div`
  flex: 0 0 calc(50% - 1rem);
  max-width: 50%;
  height: 20rem;
  :hover {
    transform: scale(0.95);
  }

  :nth-of-type(1) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  ${({ cardcss }) => `
    background-image: url(${cardcss?.bg_img});
    background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
  `}

  .cover {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 1rem;
  }

  box-shadow:
    0 6px 20px -4px var(--main-btn-shadow),
    0 2px 20px -4px rgb(0 0 0 / 22%),
    0 0 10px -4px #fff;
  cursor: pointer;
  border-radius: 1rem;
  border: var(--main-btn-border);
  transition: all 0.3s ease;

  .s-heading {
    position: absolute;
    bottom: 1rem;
    left: 0;
    right: 0;
    color: var(--main-btn-color);
    font-size: 1.3rem;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    max-width: 80%;
    margin: 0 auto;
  }
`;

const SExternalLinkBio = ({ options }) => {
  const { objinfo = {} } = options;
  const { icon, link, heading, img_alt } = objinfo || {};

  return (
    <ContainerDiv className="t-mb-2 t-pr" cardcss={{ bg_img: icon }}>
      <a href={link} className="link" target="_blank" rel="noopener noreferrer">
        <div className="cover"></div>

        <span className="s-heading">{heading}</span>
        <span className="t-sr-only">{img_alt}</span>
      </a>
    </ContainerDiv>
  );
};

export default SExternalLinkBio;
